<template>
  <div class="activity-container" :style="onActivityTime && hasEligibility ? 'position: fixed' :'position: relative'">
    <div class="activity-logo">
      <img src="../../assets/images/extra-logo.png"/>
    </div>
    <div class="activity-winning-record">
      <img src="../../assets/images/redPacketRain/mobile/record.png" @click="viewWinningRecord"/>
    </div>
    <div class="activity-redPacket">
      <img src="../../assets/images/redPacketRain/mobile/red-packet.png"/>
    </div>
    <div class="activity-title">
      <img src="../../assets/images/redPacketRain/mobile/title.png"/>
    </div>
    <div class="activity-time">
      <img src="../../assets/images/redPacketRain/mobile/time.png"/>
    </div>
    <div class="activity-raiders">
      <img class="activity-raiders-bg" src="../../assets/images/redPacketRain/mobile/activity-raiders.png"/>
      <div class="activity-raiders-title">
        <strong>活动时间:</strong>1月24日(除夕团圆夜)
      </div>
      <div class="activity-raiders-footer">三个整点嗨抢不停，积分好礼整装待发</div>
    </div>
    <div class="activity-prize">
      <img class="activity-prize-bg" src="../../assets/images/redPacketRain/mobile/prize-bg.png"/>
    </div>
    <div class="activity-desc">
      <img src="../../assets/images/redPacketRain/mobile/desc-bg.png"/>
      <div class="activity-desc-detail">
        <div>
          <strong><b>|</b>活动时间:</strong>
          <div>1月24日(除夕) 20点、22点、24点,3个整点时间开始红包雨游戏,记得准时参加哦</div>
        </div>
        <div class="activity-desc-wrapper">
          <strong><b>|</b>游戏玩法:</strong>
          <div>红包雨游戏开始后,点击掉落的红包即有机会获得奖品</div>
        </div>
        <div class="activity-desc-wrapper">
          <strong><b>|</b>奖品发放:</strong>
          <div>红包积分实时充至中奖账户,实物奖品将于年后发出</div>
        </div>
      </div>
    </div>

    <div class="pop-dialog" v-show="showWinningRecord">
      <div class="pop-bg">
        <div class="pop-winning-record">
          <div>
            <img src="../../assets/images/redPacketRain/mobile/record.png"/>
          </div>

          <div v-if="hasWinning">
            <div class="pop-text text-wrapper">
              <strong>时间</strong>
              <div v-for="item in prizeList" :key="item.id">{{ item.attendTime | parseTime('{h}:00') }}</div>
            </div>
            <div class="pop-text text-wrapper">
              <strong>奖品</strong>
              <div v-for="item in prizeList" :key="item.id">{{ item.itemName || `${item.pointValue}积分` }}</div>
            </div>
          </div>

          <div v-else class="pop-noWinning">
            <div class="pop-text">
              <strong>暂未获得红包噢</strong>
              <div>继续加油吧</div>
            </div>
          </div>
        </div>
      </div>

      <div class="pop-btn-close">
        <img @touchstart="handleCloseWinningRecord" src="../../assets/images/redPacketRain/mobile/btn-close.png"/>
      </div>
    </div>

    <div class="pop-dialog" v-show="showCountDownTime">
      <div class="pop-count-down">
        <div class="time-hour">
          <span>{{ differenceTime.slice(0, 1) }}</span>
          <span>{{ differenceTime.slice(1, 2) }}</span>
          <img src="../../assets/images/redPacketRain/mobile/colon.png">
        </div>
        <div class="time-minute">
          <span>{{ differenceTime.slice(2, 3) }}</span>
          <span>{{ differenceTime.slice(3, 4) }}</span>
          <img src="../../assets/images/redPacketRain/mobile/colon.png">
        </div>
        <div class="time-second">
          <span>{{ differenceTime.slice(4, 5) }}</span>
          <span>{{ differenceTime.slice(5, 6) }}</span>
        </div>
      </div>

      <div class="pop-btn-close">
        <img @touchstart="handleCloseCountTime" src="../../assets/images/redPacketRain/mobile/btn-close.png"/>
      </div>
    </div>

    <red-packet-pop
      v-if="onActivityTime && hasEligibility"
      @handleClosePop="handleClosePop"
      :activityTimeList="activityTimeList"
      :currentActivityEndTime="currentActivityEndTime"
      :currentActivityStartTime="currentActivityStartTime">
    </red-packet-pop>
  </div>
</template>

<script>
import RedPacketPop from './components/red-packet-pop'
import activityApi from '@/api/activity'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'

export default {
  name: 'RedPacketRain',
  components: {
    RedPacketPop
  },
  created () {
    this.loginAuthentication()
  },
  beforeDestroy () {
    clearInterval(this.timerActivityCountDown)
    clearInterval(this.timerDelay)
  },
  data () {
    return {
      onActivityTime: false,
      hasEligibility: false,
      clientInfo: '',
      showWinningRecord: false,
      hasWinning: false,
      prizeList: [],
      activityTimeList: [],
      nextActivityStartTime: '',
      currentActivityStartTime: '',
      currentActivityEndTime: '',
      showCountDownTime: false,
      differenceTime: '000000',
      timerActivityCountDown: '',
      timerDelay: ''
    }
  },
  methods: {
    loginAuthentication () {
      this.clientInfo = userUtils.getClientInfo()
      if (!this.clientInfo) {
        window.location.href = commonUtils.getExtraSite() + '/#/login'
        return
      }
      if (this.clientInfo.marketName.toUpperCase() === 'IAM') {
        commonUtils.configWxJsSdk().catch(error => {
          this.$emit('error', { errorMsg: error })
        })
        this.isOnActivityTime()
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '本活动仅限IAM市场用户参与'
        }).then(() => {
          window.location.href = commonUtils.getExtraSite()
        })
      }
    },
    // 检查是否在活动时间内
    isOnActivityTime () {
      // const activityList = [{
      //   startDate: 1578978960000, // 2020/01/14 13：16
      //   endDate: 1578979080000, // 2020/01/14 13：18
      //   itemName: '第一场'
      // }, {
      //   startDate: 1578979500000, // 2020/01/14 13：25
      //   endDate: 1578979620000, // 2020/01/14 13：27
      //   itemName: '第三场'
      // }]

      this.onActivityTime = false
      activityApi.getActivityTime().then(response => {
        if (response.data.resultCode === '0') {
          const currentTime = new Date().getTime()
          this.activityTimeList = response.data.resultData.activityList
          this.activityTimeList.forEach(item => {
            // 判断是否在活动时间内
            if (currentTime >= item.startDate && currentTime <= item.endDate) {
              console.log(item.activityName)
              this.onActivityTime = true
              this.checkEligibility()
              this.currentActivityStartTime = item.startDate
              this.currentActivityEndTime = item.endDate
            }
          })
          // 时间排序
          this.activityTimeList.sort((a, b) => {
            return a.startDate - b.startDate
          })
          // 获取下一场红包雨时间
          for (let i = 0; i < this.activityTimeList.length; i++) {
            if (currentTime < this.activityTimeList[i].startDate) {
              this.nextActivityStartTime = (i === this.activityTimeList.length ? 0 : this.activityTimeList[i].startDate)
              break
            }
          }
          this.distanceActicityTime()
        }
      })
    },
    // 检查参加活动的资格
    checkEligibility () {
      if (this.timerDelay) clearInterval(this.timerDelay)
      console.log('emit', new Date().getTime())
      // 延迟1s发送请求
      this.timerDelay = setTimeout(() => {
        activityApi.getEligibility().then(response => {
          if (response.data.resultCode === '0') {
            console.log('return', new Date().getTime())
            this.hasEligibility = true
          } else {
            this.hasEligibility = false
          }
        })
      }, 1000)
    },
    // 判断是否显示活动倒计时弹框
    distanceActicityTime () {
      this.showCountDownTime = false
      const difference = this.nextActivityStartTime - new Date().getTime()
      console.log('difference', difference)
      if (difference < 0) return
      // 距离活动开始时间小于24H，并且不在红包雨时间段
      if (difference <= (24 * 60 * 60 * 1000) && !this.onActivityTime) {
        console.log('显示倒计时')
        this.setCountDownTime()
        this.timerActivityCountDown = setInterval(() => {
          this.setCountDownTime()
        }, 1000)
        this.showCountDownTime = true
      }
    },
    // 设置倒计时
    setCountDownTime () {
      const time = (this.nextActivityStartTime - new Date().getTime()) / 1000
      if (time <= 0 && this.timerActivityCountDown) {
        clearInterval(this.timerActivityCountDown)
        this.showCountDownTime = false
        this.loginAuthentication()
      }
      const h = parseInt(time / 60 / 60)
      const m = parseInt(time / 60 % 60)
      const s = parseInt(time % 60)
      this.differenceTime = this.completeDigits(h) + this.completeDigits(m) + this.completeDigits(s)
    },
    // 位数不足补0
    completeDigits (num) {
      return (num < 10 ? '0' + num : num).toString()
    },
    handleClosePop () {
      console.log('close')
      this.onActivityTime = false
    },
    // 查询中奖记录
    viewWinningRecord () {
      activityApi.getWinningRecord().then(response => {
        if (response.data.resultCode === '0') {
          // 判断有无中奖
          if (response.data.resultData.redBagList && response.data.resultData.redBagList.length) {
            this.prizeList = response.data.resultData.redBagList
            this.hasWinning = true
          } else {
            this.hasWinning = false
          }
        }
      })
      this.showWinningRecord = true
    },
    handleCloseWinningRecord () {
      this.showWinningRecord = false
    },
    handleCloseCountTime () {
      this.showCountDownTime = false
      clearInterval(this.timerActivityCountDown)
    }
  }
}
</script>

<style lang="less" scoped>
.activity-container {
  position: relative;
  min-height: 100%;
  width: 100%;
  padding-bottom: 15px;
  background: url("../../assets/images/redPacketRain/mobile/background.png") no-repeat;
  background-size: 100% auto;
  padding-top: 20px;
  box-sizing: border-box;
  .activity-logo {
    position: absolute;
    top: 0;
    left: 20px;
    z-index: 1;
    img {
      max-width: 100px;
    }
  }
  .activity-winning-record {
    position: absolute;
    top: 5px;
    right: 10px;
    z-index: 1;
    img {
      max-width: 80px;
    }
  }
  .activity-redPacket {
    position: absolute;
    top: 0;
    text-align: center;
    img {
      max-width: 100%;
    }
  }
  .activity-title {
    position: absolute;
    top: 150px;
    width: 100%;
    z-index: 1;
    text-align: center;
    img {
      max-width: 300px;
    }
  }
  .activity-time {
    width: 100%;
    padding-top: 350px;
    text-align: center;
    img {
      max-width: 280px;
    }
  }
  .activity-raiders {
    position: relative;
    width: 100%;
    text-align: center;
    .activity-raiders-bg {
      max-width: 90%;
    }
    .activity-raiders-title {
      position: absolute;
      width: 100%;
      top: 45px;
      line-height: 50px;
      text-align: center;
      color: white;
      strong {
        font-weight: 700;
      }
    }
    .activity-raiders-footer {
      position: absolute;
      bottom: 8px;
      width: 100%;
      color: #19444d;
    }
  }
  .activity-prize {
    position: relative;
    padding-top: 30px;
    width: 100%;
    text-align: center;
    .activity-prize-bg {
      max-width: 95%;
    }
  }
  .activity-desc {
    position: relative;
    padding-top: 30px;
    width: 100%;
    text-align: center;
    img {
      max-width: 95%;
    }
    b {
      // font-weight: 800;
      margin-left: -2px;
    }
    .activity-desc-detail {
      position: absolute;
      top: 80px;
      line-height: 20px;
      text-align: left;
      padding: 0 40px;
      color: #307e83;
      font-size: 12px;
      .activity-desc-wrapper {
        padding-top: 15px;
      }
    }
  }
  .pop-dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    width: calc(100vw);
    padding: calc(20vh) calc(10vw) 0 calc(10vw);
    text-align: center;
    background-color: rgba(0, 0, 0, .6);
    z-index: 10;
    .pop-bg {
      z-index: 4;
      height: 350px;
      margin-bottom: 20px;
      text-align: center;
      background: url("../../assets/images/redPacketRain/mobile/pop-bg.png") no-repeat;
      background-size: 100% 100%;
      .pop-winning-record {
        padding-top: 45%;
        img {
          width: 100px;
        }
        .text-wrapper {
          width: 50%;
          strong {
            display: inline-block;
            padding-bottom: 5px;
          }
          div {
            padding-top: 3px;
          }
        }
        .pop-text {
          display: inline-block;
          color: #666;
          line-height: 20px;
          strong {
            font-size: 20px;
          }
          div {
            font-size: 16px;
          }
        }
        .pop-noWinning {
          div {
            line-height: 40px;
          }
        }
      }
    }
    .pop-count-down {
      z-index: 4;
      height: 350px;
      text-align: center;
      background: url("../../assets/images/redPacketRain/mobile/count-time.png") no-repeat;
      background-size: 100% auto;
      .time-hour, .time-minute, .time-second {
        display: inline-block;
        padding-top: 55%;
        span {
          display: inline-block;
          width: 30px;
          line-height: 50px;
          margin: 0 2px;
          background: url("../../assets/images/redPacketRain/mobile/text-bg.png") no-repeat;
          background-size: 100% 100%;
          font-size: 28px;
          font-weight: 600;
          color: #bf0e24;
        }
        img {
          width: 6px;
          padding: 0 2px;
        }
      }
    }
    .pop-btn-close {
      img {
        max-width: 40px;
      }
    }
  }
}
</style>
